export const typeArray = {
  setProductList: "setProductList",
  setUserProfile: "setUserProfile",
  setLoginDataAction: "setLoginDataAction",
  setTaskList: "setTaskList",
};
